import HomeComp from "./components/HomeComp";
import NavbarComp from "./components/NavbarComp";
import { Routes, Route } from "react-router-dom";
import AgentsComp from "./components/AgentsComp";
import FooterComp from "./components/FooterComp";
import AboutComp from "./components/AboutComp";
import MapsComp from "./components/MapsComp";
import MapasHomeComp from "./components/MapasHomeComp";
import ArmasHomeComp from "./components/ArmasHomeComp";
import ModosHomeComp from "./components/ModosHomeComp";
import AgentsHomeComp from "./components/AgentsHomeComp";
import SpraysHomeComp from "./components/SpraysHomeComp";
import RolesHomeComp from "./components/RolesHomeComp";
import SkinsHomeComp from "./components/SkinsHomeComp";
import SkinsComp from "./components/SkinsComp";
import SkinsArmasHomeComp from "./components/SkinsArmasHomeComp";
import PoliticaAPP from "./components/PoliticaComp";
import MantenimientoComp from "./components/MantenimientoComp";
import NotFound from "./components/NotFound";


function App() {
  return (
    <>
      <NavbarComp />
      <Routes>
        <Route path="*" element={<MantenimientoComp />} exact />
        <Route path="politica" element={<PoliticaAPP/>} exact /> 

        {/* <Route path='*' element={<NotFound />}/>
        <Route path="/" element={<HomeComp />} exact />
        <Route path="agents" element={<AgentsHomeComp />} exact />
        <Route path="agents/:agentName" element={<AgentsComp />} exact />
        <Route path="about" element={<AboutComp />} exact />
        <Route path="mapas" element={<MapasHomeComp />} exact />
        <Route path="mapas/:mapaName" element={<MapsComp />} exact />
        <Route path="roles" element={<RolesHomeComp/>} exact />
        <Route path="armas" element={<ArmasHomeComp />} exact />
        <Route path="skins" element={<SkinsArmasHomeComp />} exact />
        <Route path="skins/:skinsName" element={<SkinsComp />} exact />
        <Route path="skinsPacks" element={<SkinsHomeComp />} exact />
        <Route path="modos" element={<ModosHomeComp />} exact />
        <Route path="sprays" element={<SpraysHomeComp />} exact />*/}
       

      </Routes>
      <FooterComp/>
    </>
  );
}

export default App;